<template lang="pug">
  div(class="ai-fields-generation")
    div(class="ai-fields-generation__image")
      v-img(
        :src="require('~/assets/images/templates-ai/ai-generation-banner-img.png')"
        width="100%"
        height="200"
      )
    div(class="ai-fields-generation__content")
      h2(class="title-32px bold pb-2") {{ $t('Create template with AI') }}
      div(class="text-14px pb-6") {{ $t('We are just training AI to recognize fields, so the result may be inaccurate. But it already works well with documents that have underlining like ________.') }}
      div(class="text-14px dark pb-2") {{ $t('AI understands the context and determines the field types') }}
      div(class="d-flex align-center justify-space-between mt-2")
        v-img(
          :src="require('~/assets/images/templates-ai/text-field.png')"
          max-width="204"
          height="40"
        )
        v-img(
          :src="require('~/assets/images/templates-ai/date-field.png')"
          max-width="204"
          height="40"
        )
        v-img(
          :src="require('~/assets/images/templates-ai/signature-field.png')"
          max-width="204"
          height="40"
        )
      div(class="two-buttons-wrapper pt-8")
        v-btn(
          height="48"
          @click="handleClose"
        ) {{ $t('Next time') }}
        v-btn(
          class="main-button"
          @click="handleConfirm"
        )
          div(class="d-flex align-center")
            e-svg-icon(class="mr-2") magicpen-white
            | {{ $t('Try AI now') }}
      div(class="text-12px text-center mt-4") {{ $t('Hint: It works best with documents that have underlining ___________ indicating the fields to fill in') }}
</template>

<script>
export default {
  name: 'BlockAiFieldsGeneration',
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    handleClose() {
      this.closeModal(false)
    },
    handleConfirm() {
      this.closeModal(true)
    }
  }
}
</script>

<style scoped lang="scss">
.ai-fields-generation {
  &__content {
    padding: 32px 40px 40px 40px;
  }
}
</style>
